import {
  Base64
} from 'js-base64';
import ui from '../ui';
import router from '../app/router';
import auth from '../auth';
import API from "@/api";
import localStorage from "@/utils/localStorage";
import env from '@/utils/env';
import _ from '@/utils/datetime';
import thirdLogin from '../auth/thirdLogin.js';
import enterpriseList from '@/DATA/enterprise-list.js';

let __last_auth = null;
let __token_promise = null;

// 设置缓存为新的Promise
// 注意不要在Promise结束前再次调用！！！所以get和refresh方法都做了判断。
// TODO: 参数，超时，resolve的结果是否合理。
function set_token(p) {
  __last_auth = null;
  __token_promise = p.then(({
    authcode
  }) => {
    __last_auth = 'Basic ' + Base64.encode(authcode);
    return {
      Authorization: __last_auth
    };
  });

  __token_promise.catch(() => {
    __token_promise = null;
    __last_auth = null;
  });

  return __token_promise;
}

const bridge = {
  // 获取access_token
  get() {
    if (!__token_promise) {
      set_token(auth.getToken());
    }

    return __token_promise;
  },

  // 获取【此刻的】access_token
  getSync() {
    return {
      Authorization: __last_auth
    };
  },

  // 为了避免在很短时间内多次刷新，这里会比较传入的无效token与缓存的是否一致
  refresh({
    invalidAuth
  } = {}) {
    if (__last_auth && invalidAuth === __last_auth) {
      console.info(`refresh token @${new Date()}`);
      set_token(auth.refreshToken());
    }
  },

  login(...args) {
    __token_promise = null;
    __last_auth = null;
    return auth.login(...args);
  },

  logout() {
    __token_promise = null;
    __last_auth = null;
    return auth.logout();
  },

  ensure(...args) {
    const tryToLogin = () => {
      return this.login(...args).catch((e) => {
        throw e
      })
    }

    return this.get().then(() => {
      let refreshExpiretime = localStorage.get('refreshExpiretime')
      refreshExpiretime = refreshExpiretime ? _.toDate(refreshExpiretime).getTime() : null

      if (env.isNative || refreshExpiretime && refreshExpiretime > Date.now() || !refreshExpiretime) {
        return
      } else {
        return tryToLogin()
      }
    }).catch(e => {
      if (e && e.name === 'AuthError') {
        return tryToLogin()
      } else {
        throw e
      }
    });
  }
};

bridge.get = bridge.get.bind(bridge);
bridge.refresh = bridge.refresh.bind(bridge);
bridge.login = bridge.login.bind(bridge);
bridge.ensure = bridge.ensure.bind(bridge);

export default bridge;

//
// 安装路由authorize
//

router.beforeEach(authorize);


// 每次进入项目尝试延长刷新token？？？
// setTimeout(auth.extendRefreshToken, 3000)



/* global HLCX_H5_BASE_URL */
const baseUrl = HLCX_H5_BASE_URL;

function getFullUrl(fullPath) {
  return baseUrl + fullPath;
}

/**
 * meta auth及相关参数说明:
 * auth: true => 当前页面需登录(包含客户单登录、手机号验证码登录、微信登录（ps: 如果需要走高铁微信网页授权需要配置 gtWechatAuth: true）)
 * authConfig: {
 *  thirdAuthChannel => 当前页面在对应第三方渠道时需要走第三方登录
 *  gtWechatAuth: true => 当前页面在微信端需要走高铁微信登录
 *  hbWechatOpenid: true => 当前页面需要走航班微信授权获取航班openid (hbWechatOpenid为true时, gtWechatAuth一定为true)
 * }
 */

function authorize(to, from, next) {
  let auth = to.meta && to.meta.auth || false;
  let authConfig = to.meta && to.meta.authConfig || null;
  const ptid = localStorage.get("ptid") || (to.query && to.query.ptid) || "";

  if (authConfig) {
    if (authConfig.thirdAuthChannel && authConfig.thirdAuthChannel.indexOf( ptid ) >= 0 ) { //在第三方平台,进行第三方登录
      authorizeByPtid(ptid, to, from, next);
    } else if (env.isWeixin && authConfig.gtWechatAuth) { //在微信端,进行微信登录
      if (thirdLogin.checkNeedThirdLogin()) {
        // 第三方平台微信环境
        if (auth) {
          ensureLogin(to, from, next);
        } else {
          next();
        }
      } else {
        ensureWxLogin(to, from, next, authConfig);
      }
    } else if (auth) {
      ensureLogin(to, from, next);
    } else {
      next();
    }
  } else if (auth) { //走默认登录
    ensureLogin(to, from, next);
  } else {
    next();
  }
}


// 第三方平台登录
function authorizeByPtid(ptid, to, from, next) {
  if (ptid === "maycur") {
    const phone = to.query && to.query.phone || "";
    if (phone) {
      // 先把authcode删除
      localStorage.remove('authcode');

      API.login["331623"]({
        passengerMobile: phone,
        maycurSignValue: to.query && to.query.mid || '',
        timestamp: to.query && to.query.timestamp || ''
      }).then(r => {
        if (r && r.authcode) {
          localStorage.set('authcode', r.authcode);
          next();
        } else {
          throw null;
        }
      }).catch(err => {
        console.error(`query authcode by phone error: ${err}`);
        ensureLogin(to, from, next);
      })
    } else {
      ensureLogin(to, from, next);
    }
  } else if ( enterpriseList.indexOf( ptid ) >= 0 ) {
    ensureLogin( to, from, next );
  } else {
    //以后别的渠道还有这样的需求再单独处理
    next();
  }
}

// 微信登录
function ensureWxLogin(to, from, next, authConfig) {
  bridge.ensure({
    target_url: getFullUrl(to.fullPath),
    rp: to.fullPath
  }).then(() => {
    if (authConfig.hbWechatOpenid && !localStorage.get('hbOpenid')) { //需要航班网页授权获取openid进行支付
      auth.loginHb({
        target_url: getFullUrl(to.fullPath)
      })
    } else {
      next();
    }
  }, e => {
    ui.showNotification({
      message: e && e.message
    });
  });
}

// 默认登录
function ensureLogin(to, from, next) {
  bridge.ensure({
    target_url: getFullUrl(to.fullPath),
    rp: to.fullPath
  }).then(next, e => {
    // 客户端取消登录或者登录失败不报错，快应用取消登录或者登录失败不报错
    if (!(e && (e.platform === 'app' || e.platform === 'quickapp' || e.name === 'ToHangbanLogin'))) {
      ui.showNotification({
        message: e && e.message
      });
    }
  });
}



// WEBPACK FOOTER //
// ./src/request/auth.js